import { useQuery } from '@tanstack/react-query';
import { useActivePage } from '@toolpad/core';
import { useParams } from 'react-router';
import { Stack } from '@mui/material';

import { QueryRenderer } from '@barboxx/admin-components';
import Api from '@barboxx/api';
import { Can } from '@barboxx/react-utils';

import { RootContainer } from '../../components/nav/RootContainer';
import { SubstitutionDeleteCard } from './components/SubstitutionDeleteCard';
import { SubstitutionDetailsCard } from './components/SubstitutionDetailsCard';

export function SubstitutionDetails() {
    const { id } = useParams();
    const activePage = useActivePage();

    const substitutionQueryResults = useQuery({
        queryKey: ['substitution', id],
        queryFn: () => Api.Core.Substitution.getSubstitution(Number(id)),
    });

    const breadcrumbs = [
        ...(activePage?.breadcrumbs ?? []),
        {
            title: 'Details',
            path: `${activePage?.path}/${id}`,
        },
    ];

    return (
        <RootContainer maxWidth="md" breadcrumbs={breadcrumbs}>
            <QueryRenderer results={substitutionQueryResults}>
                {data => {
                    return (
                        <Stack gap={2} sx={{ paddingBottom: 4 }}>
                            <SubstitutionDetailsCard substitution={data} />

                            <Can I="delete" a="Substitution">
                                <SubstitutionDeleteCard substitution={data} />
                            </Can>
                        </Stack>
                    );
                }}
            </QueryRenderer>
        </RootContainer>
    );
}
